import { api } from "@/lib/api";
import { toast } from "sonner";

export const downloadAuth = async (path, filename, params) => {
  try {
    const r = await api.get(path, { responseType: "blob", params });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(r.data);
    a.download = filename;
    a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 4000);
  } catch {
    toast.error("Download non riuscito");
  }
};

export const eur = (n) => `€ ${Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: "always" })}`;
export const itDate = (d) => (d ? new Date(d.length === 10 ? `${d}T12:00:00` : d).toLocaleDateString("it-IT") : "");
export const errMsg = (e, fb = "Operazione non riuscita") => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg).join(" · ") : fb;
};
